export const items=["home","women","men","contact"]